// extracted by mini-css-extract-plugin
module.exports = {"title":"search-title_title__LcQfE"};